import { useNavigate, useLocation } from "react-router-dom";
import { LayoutDashboard, Settings, ArrowLeft, BookOpen } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/api";

export default function CauShell({ children }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const onDash = loc.pathname === "/cauzioni-pro";

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <header className="no-print border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-[1400px] px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button onClick={() => nav("/dashboard")} data-testid="cau-back-hub"
              className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900 px-2 py-1.5 rounded-md hover:bg-slate-100 transition-all">
              <ArrowLeft size={15} /> Suite
            </button>
            <div className="h-5 w-px bg-slate-200" />
            <button onClick={() => nav("/cauzioni-pro")} className="flex items-center gap-3" data-testid="cau-brand-link">
              <img src={LOGO_URL} alt="Assietica Soc. Coop." className="h-9 w-auto object-contain [.suite-shell_&]:hidden" />
              <div className="hidden sm:block border-l border-slate-200 pl-3 leading-tight">
                <div className="font-display text-sm font-extrabold text-slate-900">CauzioniPro</div>
                <div className="text-[10px] uppercase tracking-widest text-slate-400">Istruttoria Fideiussoria</div>
              </div>
            </button>
          </div>
          <div className="flex items-center gap-4">
            {!onDash && (
              <button onClick={() => nav("/cauzioni-pro")} className="flex items-center gap-1.5 text-sm text-slate-600 hover:text-slate-900" data-testid="cau-nav-dashboard">
                <LayoutDashboard size={16} /> Pratiche
              </button>
            )}
            <button onClick={() => nav("/manuale/cauzioni")} className="flex items-center gap-1.5 text-sm text-slate-600 hover:text-slate-900" data-testid="cau-nav-manuale">
              <BookOpen size={16} /> Manuale
            </button>
            {user?.role === "admin" && (
              <button onClick={() => nav("/cauzioni-pro/impostazioni")} className="flex items-center gap-1.5 text-sm text-slate-600 hover:text-slate-900" data-testid="cau-nav-settings">
                <Settings size={16} /> Impostazioni
              </button>
            )}
            <div className="text-right leading-tight hidden sm:block">
              <div className="text-sm font-medium text-slate-800">{user?.name}</div>
              <div className="text-[11px] uppercase tracking-wide text-slate-400">{user?.role}</div>
            </div>
          </div>
        </div>
      </header>
      <main className="flex-1">{children}</main>
    </div>
  );
}
